// CONFIGS
const urlConfig = {
	backend: 'https://desing-back.klausurencoach.de',
}

export default urlConfig